import { useEffect } from 'react';
// import 'antd/dist/reset.css';
import { AccountProvider } from 'components/Provider/account';
import { AppRoutes } from 'routes/AppRoutes';
import { useAuth } from 'hooks/useAuth';

const App = () => {
  const { isReady } = useAuth();

  useEffect(() => {
    const theme = localStorage.getItem('theme');
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, []);

  if (!isReady) return null;

  return (
    <AccountProvider>
      <AppRoutes />
    </AccountProvider>
  );
};

export default App;
